import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { useEffect, useState, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { aggiorna } from '../../redux/artista'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import DivBottom from '../userNotAuth/components/divBottom'
import axios from 'axios'
import AuthProvider from '../Authentication/authProvider'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import { RotatingLines } from "react-loader-spinner"

let error = []//array gestione errori insert foto
let tipoCucinaArr = []//array di appoggio per formData.tipoCucina

function EditFoodTruck() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const foodTruck = location.state.foodTruck
    const numFoto = [0, 1, 2] // NUMERO MASSIMO DI FOTO (è l'index nel loop in html) ----------

    function createArrImgOld() {//funzione per visualizzare le foto archiviate in MYSQL 
        let arrImg = []; let arrImgName = []
        if (foodTruck.img) {//se ci sono foto in MYSQL caricale in 'setFoto' per mandarle a schermo
            arrImg = foodTruck.img.split(',')
            arrImg.forEach((item, index) => {
                arrImgName[index] = { name: item }
            })
        }; return { arrImg: arrImg, arrImgName: arrImgName }
    }
    const oldImg = createArrImgOld()

    const [emailUser, setEmailUser] = useState(localStorage.getItem('email'))
    const [formData, setFormData] = useState({
        altro: '',
        città: foodTruck.città,
        descrizione: foodTruck.descrizione,
        email: emailUser,
        fb: foodTruck.fb,
        idUser: localStorage.getItem('id'),
        nome: foodTruck.nome,
        regione: foodTruck.regione,
        specialità: foodTruck.soggetto,
        telefono: foodTruck.telefono,
        tipoCucina: foodTruck.genere,
        url: foodTruck.url,
        youtube: foodTruck.youtube,
        video: foodTruck.video
    })
    const [msg, setMsg] = useState({ foto: null, telefono: null })//messaggio email non valida
    const [msgVideo, setMsgVideo] = useState({ videoStateMessage: null })
    const [textEmpty, setTextEmpty] = useState(null)//messaggio campo vuoto in descrizione
    const [foto, setFoto] = useState(oldImg.arrImg)
    const [caricamento, setCaricamento] = useState(null)
    const [msgProgress, setMsgProgress] = useState({ string: null, failed: null })//barra del loader dopo submit 
    const [validateSpecialità, setValidateSpecialità] = useState(null)//messaggio campo vuoto in genere
    const [tipoCucinaMsg, setTipoCucinaMsg] = useState(null)
    const [progressVideo, setProgressVideo] = useState(null)// percentuale di avanzamento upload video

    const specialità = useRef()
    const altraSpec = useRef()
    const descrizione = useRef()
    const telefono = useRef()

    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default

        if (formData.specialità === '') {
            setValidateSpecialità('Campo obbligatorio'); window.scrollTo(0, 250)
            specialità.current.style.border = '1px solid red'; return
        } else
            if (formData.specialità === 'Altro' && formData.altro === '') {
                setValidateSpecialità('Campo obbligatorio'); window.scrollTo(0, 400)
                document.getElementById('altroInput').style.border = "1px solid red"; return
            }
        if (formData.tipoCucina.length === 0) {
            setTipoCucinaMsg('*** Almeno 1 tipo cucina ***'); window.scrollTo(0, 250); return
        }
        if (formData.descrizione.length < 15) {
            setTextEmpty('Almeno 15 caratteri'); window.scrollTo(0, 650)
            descrizione.current.style.border = '1px solid red'; return
        } else
            if (formData.telefono && /^[0-9\s-]+$/.test(formData.telefono) === false) {
                setMsg({ telefono: '*** Campo numerico ***' }); window.scrollTo(0, 750)
                telefono.current.style.border = '1px solid red'; return
            }

        // ---------------- SE TUTTO E' IN CHECK --------------------
        const object = { ...formData, foto: foto }
        setMsgProgress({ string: 'Caricamento in corso...' })
        try {//chiamata a server per insert in mysql del foodTruck creato
            const res = await axios.post(`/updateFoodTruck/${foodTruck.id}`, object)
            if (res.data === 'Success') {
                dispatch(aggiorna(object))
                setTimeout(() => {
                    setMsgProgress({ string: null })
                    navigate('/editFoodTruckSuccess', { replace: true })
                }, 1500)
            }
        } catch (err) { setMsgProgress({ failed: '*** Modifica foodTruck fallita...riprova ***', string: null }); console.error(err); return }
    }
    function handleChange(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
        setValidateSpecialità(null); setTextEmpty(null); setMsg({ email: null, telefono: null }); setMsgProgress({ failed: null })
        descrizione.current.style.border = '1px solid black'; telefono.current.style.border = '1px solid black'
        document.getElementById('altroInput').style.border = "1px solid lightgrey"
        specialità.current.style.border = '1px solid lightgrey'

        if (name === 'telefono') {
            if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) { setMsg({ telefono: '*** Campo numerico ***' }) }
        }
        if (name === 'specialità' && value === 'Altro') {
            altraSpec.current.style.display = 'block'
        } else
            if (name === 'specialità' && value !== 'Altro' && altraSpec.current.style.display === 'block') {
                altraSpec.current.style.display = 'none'
            }
        if (name === 'altro') setFormData({ ...formData, specialità: inputValue })
    }
    function handleTipoCucina(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        if (inputValue === true) {
            tipoCucinaArr.push(name)
        } else
            if (inputValue === false) {
                tipoCucinaArr = tipoCucinaArr.filter(item => item !== name)
            }
        setFormData({ ...formData, [name]: inputValue, tipoCucina: tipoCucinaArr })
    }
    const imageChange = async (e) => {
        if (e.target.files[0]) {
            const el = e.target.getAttribute('data-val')//posizione della foto in array 'foto'
            const eT = e.target.files[0]
            if (eT.type.startsWith('image/')) {
                setCaricamento('Caricamento in corso, attendere...')
                error = []; setMsg(null)

                // RINOMINAZIONE FOTO CON NOME RANDOM
                let extens = eT.name.substring(eT.name.lastIndexOf('.') + 1)// ricavo l'estensione
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                let result = ''
                const charactersLength = characters.length
                for (let i = 0; i < 15; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength))
                }
                const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto

                // ------ ACCETTAZIONE IMMAGINE ----------------------------------------   
                try {
                    const fd = new FormData()
                    fd.append('foto', eT); fd.append('nomeFoto', zxc); fd.append('stato', 'siAwsBucket')
                    const res = await axios.post('/convertJpegBase64', fd, {
                        headers: { "Content-Type": "multipart/form-data" }
                    })
                    if (res.data === 'success') {
                        setFoto(foto.concat(`ZE_${result}.webp`))//per preview 
                        setCaricamento(null)
                        document.getElementById('label' + el).style.display = 'none'// tolgo '+foto'
                        el < numFoto.length - 1 && ( //risettaggio input disabled = false
                            document.getElementById('upload-photo' + (parseInt(el) + 1)).disabled = false)
                    } else {//upload foto failed
                        document.getElementById('upload-photo' + el).value = ''
                        setCaricamento('*** problemi con il server...riprova ***')
                    }
                } catch (err) { console.log(err) }
            } else {
                //immagine type non conforme
                error[el] = 'Tipo immagine non conforme'
                setMsg(error)
                e.target.value = ""; return
            }
        }
    }
    const imageRemove = async (e) => {
        setMsg({ ...msg }); error = []
        const el = e.target.getAttribute("data-val")//posizione della foto da eliminare in array 'foto'
        document.getElementById('upload-photo' + el).value = ''
        const bj = foto.length - 1

        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                const nj = [...foto]
                nj.splice(el, 1)
                setFoto(nj)
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('label' + bj).style.display = 'block'//visualizzo '+foto'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-img/${foto[el]}`)
        } catch (err) { setCaricamento('*** Problemi con il server...riprova ***'); console.error(err); return }
        removeFadeOut(document.getElementById('preview' + el), 200)
        removeFadeOut(document.getElementById('iconaElimina' + el), 200)
        //RISETTAGGIO INPUT FOTO = DISABLED
        let index = foto.length - 1
        for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
            if (h > (index + 1)) {
                document.getElementById('upload-photo' + (h - 1)).disabled = true
            }
        }
    }
    const videoChange = async (e) => {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {// video conforme
                if (ETarget.size > 100000000) {
                    setMsgVideo({ ...msgVideo, videoStateMessage: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                document.getElementById('rotaryVideo').style.display = 'block'
                setMsgVideo({ ...msgVideo, videoStateMessage: 'Attendere...upload video in corso' })
                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration
                    if (duration > 300) {
                        setMsgVideo({ ...msgVideo, videoStateMessage: '*** Video troppo lungo (max 5 min) ***' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'

                    } else {// ------ ACCETTAZIONE VIDEO ---------------------------------------- 
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione  
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}`// aggiungo ZE alla stringa random che darà il nome al video
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setMsgVideo({ ...msgVideo, string: 'Video caricato con successo' })
                            setFormData({ ...formData, video: videoName }) //formData2.video è il nome che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setMsgVideo({ ...msgVideo, string: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {// ---------------- video type non conforme ----------------- 
                setMsgVideo({ ...msgVideo, videoStateMessage: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    const videoRemove = async (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData({ ...formData, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-video/${formData.video}`)
        } catch (err) { setMsgVideo({ ...msgVideo, videoStateMessage: '*** Problemi con la connessione ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setMsgVideo({ videoStateMessage: null })
    }

    useEffect(() => {// settaggio input disabled
        if (foto.length < numFoto.length - 1) {
            let fotoLength = foto.length;
            for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
                if (h > (fotoLength + 1)) {
                    document.getElementById('upload-photo' + (h - 1)).disabled = true
                }
            }
        }
        if (foto.length !== 0) { // settaggio label dentro il div dell'input delle foto (+foto)
            for (let x = 0; x < foto.length; x++) {
                document.getElementById('label' + x).style.display = 'none'
            }
        }
        // console.log('foto:', foto)
    }, [foto])

    useEffect(() => {
        if (formData.video) {
            document.getElementById('lblVideo').style.display = 'none' // se c'è un video tolgo '+Video' nel primo render della pagina
        }
    }, [formData.video])

    useEffect(() => {
        if (foodTruck.genere) {//settaggio TIPO CUCINA
            tipoCucinaArr = foodTruck.genere.split(',')//array di appoggio per formData.tipoCucina []
            if (!document.getElementById('selectSpecialità').value) {//specialità in MYSQL (cognome) non è tra le option ma in 'altro' (personalizzata)
                altraSpec.current.style.display = 'block'
                document.getElementById('altroInput').value = formData.specialità
            }
            let reg = [false, false, false, false, false, false, false, false]
            tipoCucinaArr.forEach((elem, index) => {
                switch (elem) {
                    case 'italiana': reg[0] = true; break
                    case 'hamburger': reg[1] = true; break
                    case 'etnica': reg[2] = true; break
                    case 'vegetariana': reg[3] = true; break
                    case 'vegana': reg[4] = true; break
                    case 'dolci': reg[5] = true; break
                    case 'bar': reg[6] = true; break
                    case 'griglia': reg[7] = true; break
                }
            })
            setFormData({
                ...formData,
                italiana: reg[0],
                hamburger: reg[1],
                etnica: reg[2],
                vegetariana: reg[3],
                vegana: reg[4],
                dolci: reg[5],
                bar: reg[6],
                griglia: reg[7],
            })
        }
        window.scrollTo(100, 0)
    }, [])

    // useEffect(() => { console.log(formData.tipoCucina) }, [formData])

    return (<>
        <AuthProvider />
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <br /><br />
        <h2 className='m-5'>MODIFICA FOODTRUCK</h2>
        <div className='container' style={{ marginBottom: '0rem' }}>

            <form onSubmit={handleSubmit}>
                <label htmlFor='nome'>Nome *</label>
                <input className="form-control fw-bold" style={{ width: '50%' }}
                    name="nome"
                    defaultValue={formData.nome}
                    maxLength={45}
                    onChange={handleChange}
                    required
                    type="text" />

                <label htmlFor='città' className='mt-4'>Città *</label>
                <input className="form-control fw-bold" style={{ width: '50%' }}
                    name="città"
                    defaultValue={formData.città}
                    maxLength={45}
                    onChange={handleChange}
                    required
                    type="text" />

                <label htmlFor='regione' className='mt-4'>Regione *</label>
                <input className="form-control fw-bold" style={{ width: '50%' }}
                    name="regione"
                    defaultValue={formData.regione}
                    maxLength={35}
                    onChange={handleChange}
                    required
                    type="text" />

                {/* ------------------ TIPO CUCINA --------------- */}
                {tipoCucinaMsg && <p style={{ color: 'red', marginTop: '2em' }}>{tipoCucinaMsg}</p>}

                <h5 style={{ marginTop: '1rem' }}>TIPO DI CUCINA *</h5>
                <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '2rem 1fr', gap: '4px' }}>
                    <div><input type='checkbox'
                        name='italiana'
                        checked={formData.italiana}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Cucina italiana tradizionale</div>

                    <div><input type='checkbox'
                        name='hamburger'
                        checked={formData.hamburger}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Hamburger & Fast Food</div>

                    <div><input type='checkbox'
                        name='etnica'
                        checked={formData.etnica}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Etnica/Internazionale</div>

                    <div><input type='checkbox'
                        name='vegetariana'
                        checked={formData.vegetariana}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Vegetariana</div>

                    <div><input type='checkbox'
                        name='vegana'
                        checked={formData.vegana}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Vegana</div>

                    <div><input type='checkbox'
                        name='dolci'
                        checked={formData.dolci}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Dolci & Gelati</div>

                    <div><input type='checkbox'
                        name='bar'
                        checked={formData.bar}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Bar/Cocktail/Birre/Frullati/Centrifugati</div>

                    <div><input type='checkbox'
                        name='griglia'
                        checked={formData.griglia}
                        onChange={handleTipoCucina} />
                    </div>
                    <div>Griglia & Barbecue
                        <p style={{ color: 'maroon', fontSize: 'small', marginLeft: '5px' }}><i>Carne e pesce alla brace, arrosticini. </i></p>
                    </div>
                </div>

                {/* ---------------------- SPECIALITA' ------------------------- */}
                <label htmlFor='tipologia' className='mt-4'>Specialità *</label>
                <select className="form-select mt-1 fw-bold" aria-label="Default select example" style={{ width: 'auto' }}
                    name="specialità" ref={specialità} id='selectSpecialità'
                    value={formData.genere}
                    onChange={handleChange}>
                    <option value=''></option>
                    <option value="Arancini e supplì">Arancini e supplì</option>
                    <option value="Asado">Asado</option>
                    <option value="Barbecue (BBQ)">Barbecue (BBQ)</option>
                    <option value="Caffè e bevande speciali">Caffè e bevande speciali</option>
                    <option value="Cous Cous">Cous Cous</option>
                    <option value="Cucina asiatica">Cucina asiatica</option>
                    <option value="Gelato">Gelato/Dessert</option>
                    <option value="Hamburger e hot dog">Hamburger e hot dog</option>
                    <option value="Hummus e Falafel">Hummus e Falafel</option>
                    <option value="Kebab">Kebab</option>
                    <option value="Moussaka">Moussaka</option>
                    <option value="Opzioni salutari e vegane">Opzioni salutari e vegane</option>
                    <option value="Paella">Paella</option>
                    <option value="Panini con porchetta">Panini con porchetta</option>
                    <option value="Panzerotti e calzoni fritti">Panzerotti e calzoni fritti</option>
                    <option value="Piadine">Piadine</option>
                    <option value="picanha">Picanha</option>
                    <option value="Tacos e cucina messicana">Tacos e cucina messicana</option>
                    <option value="Altro">Altro</option>
                </select>
                <div ref={altraSpec} style={{ display: 'none', margin: '16px 0 0 5px' }}>
                    <label>Altra specialità del tuo FoodTruck</label>
                    <input className="form-control fw-bold mt-1" id='altroInput'
                        name="altro"
                        maxLength={45}
                        onChange={handleChange}
                        placeholder='es. patatine fritte'
                        type="text" />
                </div>
                {validateSpecialità && <p style={{ color: 'red' }}><i>{validateSpecialità}</i></p>}

                <h4 style={{ marginTop: '3rem' }}>Descrivi la tua attività *</h4>
                <p><i style={{ color: 'maroon' }}>Ad esempio qualche particolare importante delle tue offerte gastronomiche...</i></p>
                <textarea style={{ padding: '5px' }} className='form-control' ref={descrizione}
                    name="descrizione"
                    defaultValue={formData.descrizione}
                    rows='10'
                    maxLength={2000}
                    onChange={handleChange}
                >
                </textarea>
                {textEmpty && <p style={{ color: 'red' }}><i>{textEmpty}</i></p>}

                <label htmlFor='telefono' className='mt-3'>Telefono </label>
                <input className='form-control fw-bold' style={{ width: '50%' }} ref={telefono}
                    name='telefono'
                    defaultValue={formData.telefono}
                    maxLength={20}
                    onChange={handleChange}
                    type='text' />
                {msg.telefono && <p style={{ color: 'red' }}><i>{msg.telefono}</i></p>}

                <label htmlFor='email' className='mt-3'>Email </label>
                <input className="form-control" style={{ width: '50%' }}
                    defaultValue={formData.email}
                    disabled
                    type="text" />

                <h5 style={{ fontFamily: 'sans-serif', marginTop: '3rem' }}>LINK</h5>
                <div style={{ marginLeft: '1rem' }}>
                    <label htmlFor='email' className='mt-1'>URL sito web</label>
                    <input className="form-control"
                        name="url"
                        defaultValue={formData.url}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.zona-eventi.it/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL Facebook</label>
                    <input className="form-control"
                        name="fb"
                        defaultValue={formData.fb}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.facebook.com/'
                        type="text" />

                    <label htmlFor='email' className='mt-3'>URL YouTube</label>
                    <input className="form-control"
                        name="youtube"
                        defaultValue={formData.youtube}
                        maxLength={250}
                        onChange={handleChange}
                        placeholder='es: https://www.youtube.com/'
                        type="text" />
                </div>

                {/* ------------------------ aggiungi immagini ------------------------- */}
                <h4 style={{ marginTop: '3rem' }}>AGGIUNGI IMMAGINI</h4>
                <p><i>Se aggiungi un'immagine otterrai più visualizzazioni</i></p><br />
                <div className='gridAddEvento2'>
                    {numFoto.map(elem => (
                        <div key={elem} className='fotoEvento'>
                            <label htmlFor={"upload-photo" + elem} style={{ cursor: 'pointer' }} id={'label' + elem}>
                                {elem === 0 ? <span style={{ fontSize: 'small' }}>+ Foto principale</span> : <span>+foto</span>}
                            </label>
                            {foto[elem] && //preview
                                <div>
                                    <div style={{ marginTop: '-25px' }}>
                                        <button style={{ marginLeft: '5rem', border: 'transparent', backgroundColor: 'transparent' }} data-val={elem}
                                            onClick={imageRemove} id={'iconaElimina' + elem} type='button'>
                                            ❌
                                        </button>
                                    </div>
                                    <span id={'preview' + elem}>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${foto[elem]}`} style={{ maxWidth: '100px', height: '74px' }} alt="" />
                                    </span>
                                </div>
                            }
                            {error[elem] &&
                                <p id={'msg' + elem} style={{ fontSize: 'small' }}>{msg[elem]}</p>
                            }
                            <input id={'upload-photo' + elem} style={{ opacity: '0', fontSize: '0px' }}
                                type='file' data-val={elem}
                                name={'foto' + elem}
                                accept="image/*"
                                onChange={imageChange} />
                        </div>
                    ))}
                </div>
                {caricamento &&
                    <div className='mt-2' style={{ fontWeight: '600', color: 'red' }}>{caricamento}</div>
                }<br /><br />
                {/* ------------------------ aggiungi video ------------------------- */}
                <div>
                    <h4 style={{ marginTop: '0' }}>AGGIUNGI VIDEO (max 5 min)</h4>
                    <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                    <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 3em', borderRadius: '5px' }}>
                        <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                            + Video
                            <span id="rotaryVideo" style={{ display: 'none' }}>
                                <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        </label>
                        {formData.video &&
                            <div>
                                <div style={{ marginTop: '-30px' }}>
                                    <button style={{ marginLeft: '9.5rem', border: 'transparent', backgroundColor: 'transparent' }}
                                        onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                        ❌
                                    </button>
                                </div>
                                <div>
                                    {/* ------------- preview del video proveniente da MYSQL ------------ */}
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData.video}`} id={'videoPreview'}
                                        style={{ width: '197px', height: '128px', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }
                        <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                            type='file'
                            name='video'
                            accept="video/*"
                            onChange={videoChange} />
                    </div>
                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent', margin: '1em 0 0 1em' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                        </div>
                    </div>
                    {msgVideo.videoStateMessage &&
                        <p style={{ color: 'navy', margin: '0 0 0 1em' }}><i>{msgVideo.videoStateMessage} {progressVideo}</i></p>
                    }
                </div>

                {msgProgress.string &&
                    <h5 className='mt-3'>
                        <RotatingLines strokeColor='navy' strokeWidth='5' animationDuration='5' width='26' />
                        <span style={{ marginLeft: '1rem', color: 'navy' }}>{msgProgress.string}</span>
                    </h5>
                }

                {msgProgress.failed && <p style={{ color: 'red', marginTop: '1rem' }}>{msgProgress.failed}</p>}
                <hr />

                <p className='mt-5'><i>* campi obbligatori</i></p>
                <div className='mt-2'>
                    <button className='btn btn-secondary' onClick={() => {
                        navigate('/', { replace: true })
                    }}>Indietro
                    </button>
                    <button type='submit' className='btn btn-primary' style={{ marginLeft: '2em' }}>Avanti</button>
                </div>
            </form>
        </div>
        <DivBottom />
    </>)
}
export default EditFoodTruck